import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import {
  RegenerateThirdPartyTokenInterface,
  ThirdPartyAccessInterface,
  toExpirationDays,
} from '../../../models/dashboard/settings/third-party-access.model';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';
import { useAppSelector } from '../../../redux/store';

const useRegenerateThirdPartyToken = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const { businessInfo } = useAppSelector((state) => state.businessInfoData);

  const onRegenerateThirdPartyTokenError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ?? 'Something went wrong while regenerating the token.',
    );
  };

  const onRegenerateThirdPartyTokenSuccess = (email: string, callback: () => void) => ({
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success(`A new link has been sent to ${email}.`);
    callback();
  };

  const regenerateThirdPartyToken = (
    data: ThirdPartyAccessInterface,
    values: RegenerateThirdPartyTokenInterface,
    callback: () => void,
  ) => {
    const url: HttpConfig = {
      url: `api/v1/partner-api-keys`,
      method: 'put',
      data: {
        "id": data.id,
        environment: businessInfo?.isTestMode ? 'Test' : 'Live',
        expirationDays: toExpirationDays(values.expiresAt),
      },
    };

    request(url, onRegenerateThirdPartyTokenSuccess(data.partnerEmail, callback), setLoading, onRegenerateThirdPartyTokenError);
  };

  return { regenerateThirdPartyToken, loading };
};

export default useRegenerateThirdPartyToken;
